import script from "./CareerView.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerView.vue?vue&type=script&setup=true&lang=js"

import "./CareerView.vue?vue&type=style&index=0&id=bf881f3a&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf881f3a"]])

export default __exports__